module.exports = __webpack_public_path__ + "img/ic-phone.29d48fd3.svg";